import { CONFIG } from '@frameio/config';
import { ADOBE_LOGIN_PATH, WELCOME_PATH } from '../constants';

/**
 * Construct an Auth Portal login URL that will redirect back to the
 * user's current URL when they are authenticated.
 *
 * @returns The constructed login url the user should be redirected to
 */
export const getLoginUrl = (
  currentUrl: string,
  {
    authCallbackPath,
    authPortalOrigin,
    isFromAdobe = false,
  }: {
    authCallbackPath: string;
    authPortalOrigin: string;
    isFromAdobe?: boolean;
  }
): string => {
  const { origin, pathname, search } = new URL(currentUrl);

  const originToUse = origin.includes('localhost')
    ? CONFIG.appServerOrigin
    : origin;
  const searchParams = new URLSearchParams();
  searchParams.append('auth_callback', `${originToUse}${authCallbackPath}`);
  searchParams.append('redirect_path', `${pathname}${search}`);

  const loginUrl = new URL(authPortalOrigin);
  loginUrl.pathname = isFromAdobe ? ADOBE_LOGIN_PATH : WELCOME_PATH;
  loginUrl.search = searchParams.toString();
  return loginUrl.toString();
};
